import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { FederacionGestionAccion, FederacionGestionAccionJSON } from './FederacionGestionAccion';
export class FederacionGestionAccionSystem {
    private readonly base = '/federaciongestionaccions';
    constructor(private requestHandler: XhrRequestHandler) {
    }

    async getFederacionGestionAccionIdentifiedBy(id: string): Promise<FederacionGestionAccion> {
        const data = await this.requestHandler.get<FederacionGestionAccionJSON>(`${this.base}/${id}`);
        return FederacionGestionAccion.fromJSON(data);
    }

    async getList(): Promise<FederacionGestionAccion[]> {
        const data = await this.requestHandler.get<FederacionGestionAccionJSON[]>(`${this.base}`);
        return data.map((entity) => FederacionGestionAccion.fromJSON(entity))
    }

    async getListForDropdown(): Promise<FederacionGestionAccion[]> {
        const data = await this.requestHandler.get<FederacionGestionAccionJSON[]>(`${this.base}/for-dropdown`);
        return data.map((entity) => FederacionGestionAccion.fromJSON(entity))
    }

    async save(entity: FederacionGestionAccion) {
        const data = entity.toJSON();
        const savedEntity = await this.requestHandler.post<FederacionGestionAccionJSON, FederacionGestionAccionJSON>(this.base, data);
        return FederacionGestionAccion.fromJSON(savedEntity);
    }

    getBaseUrlForDatagrid() {
        return this.requestHandler.requestUrl(`${this.base}/datagrid`)
    }

    async getDatosGestionAccionByFedId(id: string): Promise<FederacionGestionAccion> {
        const data = await this.requestHandler.get<FederacionGestionAccionJSON>(`${this.base}/by-fed/${id}`);
        return FederacionGestionAccion.fromJSON(data);
      }

}

